import { workspaceVar } from './variables';

export const localWorkspace = () => {
    return workspaceVar();
};
